// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import CaretDown from "@awc/XDL/Icons/CaretDown";
import IconInputArrowDown from "@awc/XDL/Icons/IconInputArrowDown";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xBaseTheme } from "@awc/XDL/types";
import { color } from "@awc/XDL/Utilities";
import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            list: css`
                width: 100%;
                transform: translate(0, -3px);
                border: 1px solid ${color("common.ui5")};
                box-shadow: inset 0 1px 0 0 ${color("common.black", 0.1)};
                border-radius: 0 0 2px 2px;
            `,
            dropdownWrapper: css`
                && input[aria-expanded="true"] ~ ${IconWrapper} {
                    transform: rotate(180deg);
                }
            `,
            option: css`
                font-size: ${fontConfig.fontSize.small}px;
                line-height: ${fontConfig.lineHeight.singleLineSmall};
                font-weight: ${fontConfig.weight.regular};
                letter-spacing: 0;
                color: ${color("text")};
                background: ${color("common.white")};
                padding: 13px 8px;
                &:hover {
                    background: ${color("common.ui2")};
                }
                &[disabled],
                &[disabled] ~ ${IconWrapper} {
                    opacity: 0.33;
                }
            `,
            selectedText: css`
                font-size: ${fontConfig.fontSize.small}px;
                line-height: ${fontConfig.lineHeight.singleLineSmall};
                font-weight: ${fontConfig.weight.regular};
            `,
        },
        iconProps: {
            src: IconInputArrowDown,
            width: 11,
            height: 7,
            css: css`
                &&& {
                    color: ${color("common.ui5")};
                    background-color: transparent;
                    display: flex;
                    justify-content: flex-end;
                    width: auto;
                    padding-right: 12px;
                }
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
